import { render } from "./Softwaresys.vue?vue&type=template&id=230fd7d2&scoped=true"
import script from "./Softwaresys.vue?vue&type=script&lang=js"
export * from "./Softwaresys.vue?vue&type=script&lang=js"

import "./Softwaresys.vue?vue&type=style&index=0&id=230fd7d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230fd7d2"]])

export default __exports__